import { render, staticRenderFns } from "./CompleteRecovery.vue?vue&type=template&id=fd881c76&scoped=true"
import script from "./CompleteRecovery.vue?vue&type=script&lang=js"
export * from "./CompleteRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd881c76",
  null
  
)

export default component.exports